import {ModelContext} from '../../../types/app.types';
import {SPECS} from '../../specs';

export class UrlModel {
  public url: string;

  constructor(params: UrlModel) {
    this.url = params.url;
  }

  public static fromCartV1(url: string, modelContext: ModelContext) {
    return new UrlModel({
      url: UrlModel.getPartialUrl(url, modelContext),
    });
  }

  // eslint-disable-next-line sonarjs/no-identical-functions
  public static fromCartV2(url: string, modelContext: ModelContext): UrlModel {
    return new UrlModel({
      url: UrlModel.getPartialUrl(url, modelContext),
    });
  }

  private static getPartialUrl(url: string, modelContext: ModelContext) {
    return modelContext.viewerContext.isExperimentEnabled(SPECS.UsePartialLineItemUrlInCart) &&
      modelContext.baseUrl &&
      url &&
      url.startsWith(modelContext.baseUrl)
      ? url.substring(modelContext.baseUrl.length)
      : url;
  }
}
